export const MenuSuperAdmin = [
  {
    title: "Inicio",
    iconStyle: <i className="material-icons">home</i>,
    to: "dashboard",
  },
  {
    title: "Facturas Empresas",
    iconStyle: <i className="material-icons"> receipt </i>,
    to: "invoice-management",
  },
  {
    title: "Listado Facturas",
    iconStyle: <i class="material-icons"> receipt_long </i>,
    to: "listado-facturas",
  },
  {
    title: "Usuarios Empresas",
    iconStyle: <i class="material-icons"> person </i>,
    to: "usuarios-empresas",
  },
  {
    title: "Empresas",
    iconStyle: <i className="material-icons">business</i>,
    to: "business-control-panel",
  },
  {
    title: "Empleados",
    iconStyle: <i className="material-icons">person_search</i>,
    to: "all-employees",
  },
  {
    title: "Gestion Interes",
    iconStyle: <i className="material-icons">paid</i>,
    to: "interes",
  },
  {
    title: "Perfil",
    iconStyle: <i className="material-icons">account_circle</i>,
    to: "profile",
  },
];
